import {apiAuth} from '../../services/ApiService'
import {createRequest} from '../../helpers/RequestHelper'

export function validarCertificado( idDadosCertificado, onSuccess, onError ) {
    const path = `/certificados/validar/${idDadosCertificado}`
    return createRequest({
        api: apiAuth, method: 'GET', path, onSuccess, onError
    });
}


// WEBPACK FOOTER //
// ./src/view/validacao/ValidarActions.js